module.exports = __webpack_public_path__ + "img/eg-13-01.9f99ddbe.jpg";